import { KxyTheme } from "../.internal/themes/KxyTheme";
export default KxyTheme;